import React, { Fragment, Component } from 'react';
import Header from './Header';
import {Link} from "react-router-dom";
import Cookies from 'universal-cookie';
import { setPricing,textTranslation,shouldTranslateTo } from '../utils/utils';
import { decode } from 'html-entities';

const cookies = new Cookies();
const bannerStyle = (cookies.get('bC') !== '' && cookies.get('bC') !== null && cookies.get('bC') !== undefined) ? ' fb1' : ''
export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            homeData: null,
            howItWorksStr: '',
            showModal: false
        };
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }

    componentDidMount() {
        const getPricing = async () => {
            const data = await setPricing(cookies.get('cV'),cookies.get('dC'));
            const language = shouldTranslateTo();
            const getPageText = (pageValue,languageValue, data) => {
                axios
                .get(`/api/page-text/${pageValue}/${languageValue}`)
                .then(response => {
                    let pageText = response.data.map(textItem => {
                        return textItem.text;
                    });
                    var howItWorksInfo = [
                        pageText[14],
                        pageText[15]
                    ];
                    this.setState({homeData: pageText});

                    console.log('cookies.get(lC)' + cookies.get("lC"));

                    if ((cookies.get('lms') == '' || cookies.get('lms') == null) && cookies.get("lC") != 'en' && cookies.get("lC") != undefined) {
                        this.showModal();
                        cookies.set('lms', 'y', { path: '/', maxAge: 86400 });
                    }
                    var howItWorksStr = '';
                    if (cookies.get('sC')) {
                        if (cookies.get('sC').includes('sis')) {
                            howItWorksStr = howItWorksInfo[1];
                        } else {
                            howItWorksStr = howItWorksInfo[0];
                        }
                    } else {
                        howItWorksStr = howItWorksInfo[0];
                    }
                    this.setState({
                        howItWorksStr: howItWorksStr
                    });
                })
                .catch(err => {
                    console.log('Error getting page text: ', err);
                });
            }
            getPageText('home',language, data);
        }

        getPricing();
    }

    showModal() {
        this.setState({ showModal: true });
    }

    hideModal() {
        this.setState({ showModal: false });
    }

    render() {
        if (!this.state.homeData) {
            return null
        }
        return (
            <Fragment>
                <Header id="header-05" className="header">
                    <DiscountBanner/>
                    <div className={'container' + bannerStyle}>
                        <div className={'row background-container' + bannerStyle}>
                            <WelcomeMessage translated={this.state.homeData} />
                            <div className='bg-home-new'>
                                <img src={'/images/freebird-home.jpg'} alt="Join Freebird Club"/>
                            </div>
                        </div>
                        <div className="row pt-4 pt-md-0 px-md-0 cards-home-container">
                            <div className="container d-md-flex">
                                <div className="col-md-6 mb-4 mb-md-0 card card-home mr-md-2" onClick={() => this.props.history.push('search?seeking=locals')}>
                                    <div className="card-body px-0 py-3">
                                        <div className="d-flex">
                                            <div className="card-home-image">
                                                <img src="/images/home/find-locals.png" alt="Freebird find locals"/>
                                            </div>
                                            <div className="card-home-content">
                                                <p className="font-size-16">
                                                    {decode(this.state.homeData[0])}<br/>
                                                    {decode(this.state.homeData[1])}
                                                </p>
                                                <Link to="/search?seeking=locals" className="card-home-button">
                                                    {decode(this.state.homeData[2])}
                                                    <span className="float-right">
                                                        <i className="fa fa-arrow-right"></i>
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-4 mb-md-0 card card-home ml-md-2">
                                    <div className="card-body px-0 py-3">
                                        <div className="d-flex">
                                            <div className="card-home-image">
                                                <img src="/images/home/find-homestays.png" alt="Freebird find homestays"/>
                                            </div>
                                            <div className="card-home-content">
                                                <p className="font-size-16">
                                                    {decode(this.state.homeData[3])}<br/>
                                                    {decode(this.state.homeData[4])}
                                                </p>
                                                <Link to="/search?seeking=homestays" className="card-home-button">
                                                    {decode(this.state.homeData[5])}
                                                    <span className="float-right">
                                                        <i className="fa fa-arrow-right"></i>
                                                    </span>
                                                </Link>
                                                <div className="beta-badge-inline">BETA</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Header>
                <HowItWorks translated={this.state.homeData} howItWorksStr={this.state.howItWorksStr} />
                <CTA1 translated={this.state.homeData} />
                <WhySection translated={this.state.homeData} />
                <Testimonials translated={this.state.homeData} />
                <MediaLogos translated={this.state.homeData} />
                <CTA2 translated={this.state.homeData} />



                <div style={{zIndex: 9999999, position: 'absolute', height: '40px', width: '200px'}}>
                    <Modal showModal={this.state.showModal} handleClose={this.hideModal} translated={this.state.homeData}>
                        <div className="modal-body">
                            {decode(this.state.homeData[52])}
                        </div>
                    </Modal>
                </div>


            </Fragment>
        );
    }
}

const DiscountBanner = () => (
    cookies.get('bC') !== '' && cookies.get('bC') !== null && cookies.get('bC') !== undefined ?
        <section className="dba">
            <div className="container">
                <Link to='/signup'
                    onClick={e => window.fbq('track', 'Lead')}>
                    <img src={"/images/dbanner/banner-" + cookies.get('bC') + ".jpg"} alt=""/>
                </Link>
            </div>
        </section>
    :
    null
);

const WelcomeMessage = (props) => (
    <div className="col-md-5 home-intro">
        <div className="intro-text">
            <h3 className='fbc-pre-title'>{decode(props.translated[6])}</h3>
            <h1>{decode(props.translated[7])}</h1>
            <p className="pre-message">
                {decode(props.translated[8])}
            </p>
            <p className='fbc-sub-title sub-message'>
                {decode(props.translated[9])}
            </p>
        </div>
    </div>
);

const HowItWorks = (props) => (
    <section id="how-it-works" className="how-it-works">
        <div className="container">
            <div className="row">
                <div id="home-how-it-works-title" className="col-sm-12">
                    <div className="section-intro-text">
                        <h3 className='fbc-pre-title'>{decode(props.translated[10])}</h3>
                        <h1>{decode(props.translated[11])}</h1>
                        <p className="font-size-16">
                            {decode(props.translated[12])}
                        </p>
                        <h1>{decode(props.translated[13])}</h1>
                        <p className="font-size-16" dangerouslySetInnerHTML={{
                            __html: props.howItWorksStr
                        }} />
                    </div>
                </div>
                <div id="home-how-it-works-cols" className="card mb-3 border-0 col-12 px-0" style={{ maxWidth: '100%' }}>
                    <div className="row content-container">
                        <div className="col-md-6 how-left">
                            <div className="what-it-is-title-block">
                                <h2>{decode(props.translated[16])}</h2>
                            </div>
                            <img src="/images/home/how-it-works-travelers-1500.jpg" alt=""/>
                            <h5 className="card-title">{decode(props.translated[17])}</h5>
                            <p className="card-text">
                                {decode(props.translated[18])}
                            </p>
                            <h5 className="card-title">{decode(props.translated[19])}</h5>
                            <p className="card-text">
                                {decode(props.translated[20])}
                            </p>
                        </div>
                        <div className="col-md-6 how-right how-home">
                            <div className="what-it-is-title-block">
                                <h2>{decode(props.translated[21])}</h2>
                            </div>
                            <img src="/images/home/how-it-works-locals-1500.jpg" alt=""/>
                            <h5 className="card-title">{decode(props.translated[22])}</h5>
                            <p className="card-text">
                                {decode(props.translated[23])}
                            </p>
                            <h5 className="card-title">{decode(props.translated[24])}</h5>
                            <p className="card-text">
                                {decode(props.translated[25])}
                            </p>
                            <div className="beta-relative">
                                <div className="beta-badge-inline">BETA</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

const CTA1 = (props) => (
    <section id="cta-1" className="cta">
        <div className="container">
            <div className="row content-container">
                <div className="col-md-6 cta-left">
                    <h2>{decode(props.translated[26])}</h2>
                    <p className="card-text">
                        {decode(props.translated[27])}
                    </p>
                </div>
                <div className="col-md-6 cta-right">
                    <Link to='/signup'
                    className="btn btn-block btn-join text-decoration-none py-2"
                    onClick={e => window.fbq('track', 'Lead')}>
                        {decode(props.translated[28])}
                    </Link>
                </div>
            </div>
        </div>
    </section>
);

const WhySection = (props) => (
    <section id="whatMakesFreebirdSpecial" className="py-4 py-md-5">
        <div className="container">
            <div className="row">
                <div className="card mb-0 mb-md-3 border-0" style={{ maxWidth: '100%' }}>
                    <div className="row no-gutters">
                        <div className="col-md-5 image-container d-md-none px-3">
                            <img src="/images/what-makes-freebird-special.png" className="card-img" alt="what makes freebird special"/>
                        </div>
                        <div className="col-md-7 special-txt">
                            <div className="card-body pl-md-0">
                                <h5 className="card-title">{decode(props.translated[29])}</h5>
                                <p className="card-text font-size-16">
                                    {decode(props.translated[30])}
                                </p>
                                <div className="icons col-12 row">
                                    <div className="col-6 d-flex px-0 my-3">
                                        <div className="icon-container">
                                            <img src="/images/icons/travel.svg" alt=""/>
                                        </div>
                                        <span>
                                            {decode(props.translated[31])}
                                        </span>
                                    </div>
                                    <div className="col-6 d-flex px-0 my-3">
                                        <div className="icon-container">
                                            <img src="/images/icons/meet-ups.svg" alt=""/>
                                        </div>
                                        <span>
                                            {decode(props.translated[32])}
                                        </span>
                                    </div>
                                    <div className="col-6 d-flex px-0 my-3">
                                        <div className="icon-container">
                                            <img src="/images/icons/local-tips.svg" alt=""/>
                                        </div>
                                        <span>
                                            {decode(props.translated[33])}
                                        </span>
                                    </div>
                                    <div className="col-6 d-flex px-0 my-3">
                                        <div className="icon-container">
                                            <img src="/images/icons/homestays.svg" alt=""/>
                                        </div>
                                        <span>
                                            {decode(props.translated[34])}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5 image-container d-none d-md-block special-img">
                            <img src="/images/what-makes-freebird-special.png" className="card-img desktop-image" alt="what makes freebird special"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

const Testimonials = (props) => (
    <section id="testimonials" className="testimonials">
        <div className="container">
            <div className="row">
                <div id="testimonials-title" className="col-sm-12">
                    <div className="section-intro-text">
                        <h1>{decode(props.translated[35])}</h1>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-6 col-md-4">
                    <div className="box-1">
                        <img src="/images/home/flag-icon-can.jpg" alt=""/>
                        <div className="testimonial-text">
                            <h3>{decode(props.translated[36])}</h3>
                            <img src="/images/home/map-pin.svg" alt=""/>
                            <h2>Annette</h2>
                            <p>
                                &quot;{decode(props.translated[37])}&quot;
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-xs-6 col-md-4">
                    <div className="box-1">
                        <img src="/images/home/flag-icon-uk.jpg" alt=""/>
                        <div className="testimonial-text">
                            <h3>{decode(props.translated[38])}</h3>
                            <img src="/images/home/map-pin.svg" alt=""/>
                            <h2>Nicola</h2>
                            <p>
                                &quot;{decode(props.translated[39])}&quot;
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-xs-6 col-xs-offset-3 col-md-4 col-md-offset-0">
                    <div className="box-1">
                        <img src="/images/home/flag-icon-ned.jpg" alt=""/>
                        <div className="testimonial-text">
                            <h3>{decode(props.translated[40])}</h3>
                            <img src="/images/home/map-pin.svg" alt=""/>
                            <h2>Johan</h2>
                            <p>
                                &quot;{decode(props.translated[41])}&quot;
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-6 col-md-4">
                    <div className="box-1">
                        <img src="/images/home/flag-icon-usa.jpg" alt=""/>
                        <div className="testimonial-text">
                            <h3>{decode(props.translated[42])}</h3>
                            <img src="/images/home/map-pin.svg" alt=""/>
                            <h2>William</h2>
                            <p>
                                &quot;{decode(props.translated[43])}&quot;
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-xs-6 col-md-4">
                    <div className="box-1">
                        <img src="/images/home/flag-icon-sou.jpg" alt=""/>
                        <div className="testimonial-text">
                            <h3>{decode(props.translated[44])}</h3>
                            <img src="/images/home/map-pin.svg" alt=""/>
                            <h2>Lola</h2>
                            <p>
                                &quot;{decode(props.translated[45])}&quot;
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-xs-6 col-xs-offset-3 col-md-4 col-md-offset-0">
                    <div className="box-1">
                        <img src="/images/home/flag-icon-aus.jpg" alt=""/>
                        <div className="testimonial-text">
                            <h3>{decode(props.translated[46])}</h3>
                            <img src="/images/home/map-pin.svg" alt=""/>
                            <h2>Mary</h2>
                            <p>
                                &quot;{decode(props.translated[47])}&quot;
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

const MediaLogos = (props) => {
    let featuredLinks = [
        {
            id: 1,
            link: 'https://www.forbes.com/sites/nextavenue/2017/12/05/the-freebird-club-an-airbnb-for-the-50-set/#3464acf6463c',
            imageLink: '/images/freebird/media/forbes.webp',
            title: "Forbes"
        },
        {
            id: 2,
            link: 'https://www.thetimes.co.uk/article/airbnb-style-hosting-site-for-over-50s-can-stop-loneliness-hmfvl6jrp',
            imageLink: '/images/freebird/media/times.webp',
            title: 'The Times'
        },
        {
            id: 3,
            link: 'https://www.independent.ie/life/travel/travel-news/empty-nesters-get-set-to-fly-36449163.html',
            imageLink: '/images/freebird/media/independent.webp',
            title: 'Independent.ie'
        },
        {
            id: 4,
            link: 'https://www.irishtimes.com/life-and-style/abroad/free-as-a-bird-and-looking-for-a-room-1.3221351',
            imageLink: '/images/freebird/media/irishtimes.webp',
            title: 'The Iris Times'
        },
        {
            id: 5,
            link: 'http://www.nextavenue.org/freebird-club-airbnb-50/',
            imageLink: '/images/freebird/media/nextavenue.webp',
            title: "Next Avenue"
        },
        {
            id: 6,
            link: 'https://www.traveler.es/experiencias/articulos/freebird-club-comunidad-viajera-para-mayores-de-50-anos/13165',
            imageLink: '/images/freebird/media/traveler.webp',
            title: "Condé Nast Traveler"
        },
        {
            id: 7,
            link: 'https://www.huffingtonpost.com/entry/airbnb-for-seniors-helps-link-travelers-with-like-minded-hosts_us_57487aa1e4b0dacf7ad4c130?guccounter=1',
            imageLink: '/images/freebird/media/huffpost.webp',
            title: "Huffpost"
        },
        {
            id: 8,
            link: 'http://www.telegraph.co.uk/property/renting/meet-the-freebird-club-a-new-typeof-airbnb-for-the-50-plus-adven/',
            imageLink: '/images/freebird/media/telegraph.webp',
            title: "The Telegraph"
        }
    ];
    return (
        <section id="place_location_05" className="place_location_05">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="sub-title">
                            <h2>{decode(props.translated[48])}</h2>
                        </div>
                    </div>
                </div>
                <div className="row ">
                    {
                        featuredLinks.map((item) => {
                            return <div className="col-6 col-sm-3 pb-30" key={item.id}>
                                <a className="image-container" href={item.link} target="_BLANK">
                                    <img
                                        src={item.imageLink}
                                        alt={item.title}
                                        className="img-fluid mx-auto d-block"
                                    />
                                </a>
                                <a href={item.link} target="_BLANK" className="btn btn-read-article btn-block">Read article</a>
                            </div>
                        })
                    }
                </div>
            </div>
        </section>
    )
};

const CTA2 = (props) => (
    <section id="cta-1" className="cta">
        <div className="container">
            <div className="row content-container">
                <div className="col-md-6 cta-left">
                    <h2>{decode(props.translated[49])}</h2>
                    <p className="card-text">
                        {decode(props.translated[50])}
                    </p>
                </div>
                <div className="col-md-6 cta-right">
                    <Link to='/signup' className="btn btn-block btn-join text-decoration-none py-2">
                        {decode(props.translated[51])}
                    </Link>
                </div>
            </div>
        </div>
    </section>
);

const Modal = ({ handleClose, showModal, children, translated }) => {
    const showHideClassName = showModal ? "modal-aaa aaa-display-block" : "modal-aaa aaa-display-none";

    return (
      <div className={showHideClassName}>
        <section className="modal-aaa-main">
            <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">{decode(translated[54])}</h5>
                <button type="button" className="close" onClick={handleClose}>
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            {children}
            <div className="modal-footer">
                <button className="btn btn-secondary" type="button" onClick={handleClose}>
                    {decode(translated[53])}
                </button>
            </div>
        </section>
      </div>
    );
};
